module.exports = __webpack_public_path__ + "static/media/refresh-icon.6b32b370.svg";